// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TagOutlinedSvg from "@fishx/icons-svg/es/asn/TagOutlined";
import FishxIcon from '../components/FishxIcon';

var TagOutlined = function TagOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TagOutlinedSvg
  }));
};

TagOutlined.displayName = 'TagOutlined';
export default React.forwardRef(TagOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TagOutlined.js
// module id = 4238
// module chunks = 0